document.addEventListener('DOMContentLoaded', () => {
  const wrapper = document.querySelector('.m-header__wrapper');
  if (wrapper) {
    wrapper.style.setProperty('will-change', 'auto', 'important');
  }

  const cartDrawer = document.querySelector('.m-cart-drawer');
  if (cartDrawer && cartDrawer.parentElement !== document.body) {
    document.body.appendChild(cartDrawer);
  }
});